"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = exports.InputCSS = void 0;

var styled_components_1 = __importStar(require("styled-components"));

var InputSizesCSS_1 = require("./InputSizesCSS");

var InputStatesCSS_1 = require("./InputStatesCSS");

var theme_1 = require("../theme");

exports.InputCSS = (0, styled_components_1.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: ", ";\n  outline: none;\n  padding: 0.8em 1em;\n  font-size: 0.9em;\n  border: 1px solid ", ";\n  border-radius: 4px;\n  &::placeholder {\n    color: ", ";\n  }\n  &[type=\"checkbox\"] {\n    margin: 0;\n    padding: 0;\n    max-height: 18px;\n    max-width: 18px;\n  }\n  ", "\n  ", "\n"])), function (props) {
  return props.width || "100%";
}, theme_1.theme.colors.white[500], theme_1.theme.colors.gray[800], InputStatesCSS_1.InputStatesCSS, InputSizesCSS_1.InputSizesCSS);
exports.Input = styled_components_1.default.input(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n"])), exports.InputCSS);